import {
  LinkOrFileCellDto,
  LinkOrFileType,
} from '@/components/table/_fieldDefinitions/linkOrFile/LinkOrFileCellDto.ts';

export const linkOrFileExportRender = (value: unknown): string => {
  const cell = value as LinkOrFileCellDto | null | undefined;
  if (!cell) return '';
  if (cell.type === LinkOrFileType.FILE) return cell.file?.fileName ?? '';
  if (cell.type === LinkOrFileType.LINK) return cell.linkUrl ?? '';
  return '';
};
